export type Entry = { [key: string]: any };

export enum ViewGroupType {
  swimlane = 'swimlane',
  column = 'column',
}
